/* PECTY FX - motor de animaciones de la home */
(function () {
  'use strict';

  var items = [];
  var ticking = false;

  function revealAll() {
    for (var i = 0; i < items.length; i++) items[i].classList.add('pfx-in');
    items = [];
  }

  function tick() {
    ticking = false;
    if (!items.length) return;

    var vh = window.innerHeight || document.documentElement.clientHeight || 0;

    // Pestana oculta o viewport desconocido: mostrar todo, nunca dejar nada invisible.
    if (!vh) { revealAll(); return; }

    var trigger = vh * 0.88;
    var left = [];
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var r = el.getBoundingClientRect();
      if (r.top < trigger && r.bottom > -60) el.classList.add('pfx-in');
      else left.push(el);
    }
    items = left;
    if (!items.length) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(tick);
  }

  function boot() {
    var secs = document.querySelectorAll('[id*="__pty_"], [id*="__px_"]');
    if (!secs.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.body.classList.add('pfx-ready');

    var mark = function (el, i, extra) {
      if (!el || el.classList.contains('pfx-anim')) return;
      el.classList.add('pfx-anim');
      if (extra) el.classList.add(extra);
      el.setAttribute('data-d', String(Math.min(i + 1, 8)));
    };

    var groups = [
      ['.card', null], ['.paso', null], ['.bd', null], ['.rc', null],
      ['.cmp tbody tr', null], ['.li li', null], ['details', null],
      ['.verdad', null], ['.med', 'pfx-zoom'], ['.box', 'pfx-right'],
      ['.eb', null], ['h1', null], ['h2', null], ['.lead', null],
      ['.sub', null], ['.hsub', null], ['.cta', null], ['.micro', null],
      ['.rd', null], ['.banda .st', null], ['.banda strong', null], ['.banda p', null]
    ];

    for (var s = 0; s < secs.length; s++) {
      var root = secs[s];
      for (var g = 0; g < groups.length; g++) {
        var list = root.querySelectorAll(groups[g][0]);
        for (var k = 0; k < list.length; k++) mark(list[k], k, groups[g][1]);
      }
      var icos = root.querySelectorAll('.bd .ico');
      for (var b = 0; b < icos.length; b++) {
        icos[b].classList.add('pfx-bounce');
        icos[b].style.animationDelay = (b * 0.09) + 's';
      }
    }

    var all = document.querySelectorAll('.pfx-anim, .pfx-bounce');
    items = [];
    for (var t = 0; t < all.length; t++) {
      if (!all[t].classList.contains('pfx-in')) items.push(all[t]);
    }

    if (reduce) { revealAll(); return; }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('visibilitychange', onScroll);
    tick();
    setTimeout(tick, 350);
    setTimeout(tick, 1200);
    window.addEventListener('load', function () { setTimeout(tick, 120); });

    // Ripple en los botones naranja
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest ? ev.target.closest('[id*="__pty_"] .btn') : null;
      if (!btn) return;
      var r = btn.getBoundingClientRect();
      var size = Math.max(r.width, r.height);
      var w = document.createElement('span');
      w.className = 'pfx-ripple';
      w.style.width = w.style.height = size + 'px';
      w.style.left = (ev.clientX - r.left - size / 2) + 'px';
      w.style.top = (ev.clientY - r.top - size / 2) + 'px';
      btn.appendChild(w);
      setTimeout(function () { if (w.parentNode) w.parentNode.removeChild(w); }, 700);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 60); });
})();
